import { createSlice } from "@reduxjs/toolkit";

import { atomicConfig } from "../../config";
import { call_api_auth } from "../../utils/services";

import { displayErrorWithTimeout } from "./errors";

const initialState = {
  advanceBusinessReportData: {},
  advanceBusinessReportLoading: false,
  advanceBusinessReportErrorMessage: null,

  sponsoredRankTrackingData: {},
  sponsoredRankTrackingDataLoading: false,
  sponsoredRankTrackingDataErrorMessage: null,

  caSponsoredRankTrackingData: {},
  caSponsoredRankTrackingDataLoading: false,
  caSponsoredRankTrackingDataErrorMessage: null,

  organicRankTrackingData: {},
  organicRankTrackingDataLoading: false,
  organicRankTrackingDataErrorMessage: null,

  caOrganicRankTrackingData: {},
  caOrganicRankTrackingDataLoading: false,
  caOrganicRankTrackingDataErrorMessage: null,

  skuASINsList: [],
  skuASINsLoading: false,
  skuASINsErrorMessage: null,

  productItemDetailsList: [],
  productItemDetailsLoading: false,
  productItemDetailsErrorMessage: null,

  advanceBusinessReportEvents: [],
  advanceBusinessReportEventsFlag: false,

  editSearchTermsLoading: false,
  addNewKeywordResponse: {},

  defaultAdvanceSelectionReport: {},
};

// A slice for recipes with our 3 reducers
const advanceBusinessReportSlice = createSlice({
  name: "businessReport",
  initialState,
  reducers: {
    getAdvanceBusinessReport: (state) => {
      state.advanceBusinessReportLoading = true;
      state.advanceBusinessReportErrorMessage = null;
      state.advanceBusinessReportData = {};
    },

    initAdvanceBusinessReport: (state) => {
      state.advanceBusinessReportData = {};
      state.advanceBusinessReportLoading = false;
      state.advanceBusinessReportErrorMessage = null;
    },
    getAdvanceBusinessReportFailure: (state, { payload }) => {
      state.advanceBusinessReportData = {};
      state.advanceBusinessReportLoading = false;
      state.advanceBusinessReportErrorMessage = payload;
    },
    getAdvanceBusinessReportSuccess: (state, { payload }) => {
      state.advanceBusinessReportData = payload;
      state.advanceBusinessReportLoading = false;
      state.advanceBusinessReportErrorMessage = null;
    },
    getSponsoredRankTrackingData: (state) => {
      state.sponsoredRankTrackingData = {};
      state.sponsoredRankTrackingDataLoading = true;
      state.sponsoredRankTrackingDataErrorMessage = null;
    },
    getSponsoredRankTrackingDataFailure: (state, { payload }) => {
      state.sponsoredRankTrackingData = {};
      state.sponsoredRankTrackingDataLoading = false;
      state.sponsoredRankTrackingDataErrorMessage = payload;
    },
    getSponsoredRankTrackingDataSuccess: (state, { payload }) => {
      state.sponsoredRankTrackingData = payload;
      state.sponsoredRankTrackingDataLoading = false;
      state.sponsoredRankTrackingDataErrorMessage = null;
    },
    getCaSponsoredRankTrackingData: (state) => {
      state.caSponsoredRankTrackingData = {};
      state.caSponsoredRankTrackingDataLoading = true;
      state.caSponsoredRankTrackingDataErrorMessage = null;
    },
    getCaSponsoredRankTrackingDataFailure: (state, { payload }) => {
      state.caSponsoredRankTrackingData = {};
      state.caSponsoredRankTrackingDataLoading = false;
      state.caSponsoredRankTrackingDataErrorMessage = payload;
    },
    getCaSponsoredRankTrackingDataSuccess: (state, { payload }) => {
      state.caSponsoredRankTrackingData = payload;
      state.caSponsoredRankTrackingDataLoading = false;
      state.caSponsoredRankTrackingDataErrorMessage = null;
    },
    getOrganicRankTrackingData: (state) => {
      state.organicRankTrackingData = {};
      state.organicRankTrackingDataLoading = true;
      state.organicRankTrackingDataErrorMessage = null;
    },
    getOrganicRankTrackingDataFailure: (state, { payload }) => {
      state.organicRankTrackingData = {};
      state.organicRankTrackingDataLoading = false;
      state.organicRankTrackingDataErrorMessage = payload;
    },
    getOrganicRankTrackingDataSuccess: (state, { payload }) => {
      state.organicRankTrackingData = payload;
      state.organicRankTrackingDataLoading = false;
      state.organicRankTrackingDataErrorMessage = null;
    },
    getCaOrganicRankTrackingData: (state) => {
      state.caOrganicRankTrackingData = {};
      state.caOrganicRankTrackingDataLoading = true;
      state.caOrganicRankTrackingDataErrorMessage = null;
    },
    getCaOrganicRankTrackingDataFailure: (state, { payload }) => {
      state.caOrganicRankTrackingData = {};
      state.caOrganicRankTrackingDataLoading = false;
      state.caOrganicRankTrackingDataErrorMessage = payload;
    },
    getCaOrganicRankTrackingDataSuccess: (state, { payload }) => {
      state.caOrganicRankTrackingData = payload;
      state.caOrganicRankTrackingDataLoading = false;
      state.caOrganicRankTrackingDataErrorMessage = null;
    },
    getSkuASINsList: (state) => {
      state.skuASINsList = [];
      state.skuASINsLoading = true;
      state.skuASINsErrorMessage = null;
    },
    getSkuASINsListSuccess: (state, { payload }) => {
      state.skuASINsList = payload;
      state.skuASINsLoading = false;
      state.skuASINsErrorMessage = null;
    },
    getSkuASINsListFailure: (state, { paylaod }) => {
      state.skuASINsList = false;
      state.skuASINsErrorMessage = paylaod;
      state.skuASINsLoading = false;
    },

    getProductItemDetails: (state) => {
      state.productItemDetailsList = [];
      state.productItemDetailsLoading = true;
      state.productItemDetailsErrorMessage = null;
    },
    getProductItemDetailsSuccess: (state, { payload }) => {
      state.productItemDetailsList = payload;
      state.productItemDetailsLoading = false;
      state.productItemDetailsErrorMessage = null;
    },
    getProductItemDetailsFailure: (state, { payload }) => {
      state.productItemDetailsList = [];
      state.productItemDetailsLoading = false;
      state.productItemDetailsErrorMessage = payload;
    },
    resetRankTracking: (state) => {
      state.rankTrackingData = {};
      state.organicRankTrackingData = {};
    },
    resetCaRankTracking: (state) => {
      state.caRankTrackingData = {};
      state.caOrganicRankTrackingData = {};
    },
    setDefaultAdvanceSelectionReport: (state, { payload }) => {
      state.defaultAdvanceSelectionReport = {
        ...state.defaultAdvanceSelectionReport,
        ...payload,
      };
    },
    getAdvanceBusinessReportEventsSuccess: (state, { payload }) => {
      state.advanceBusinessReportEvents = payload;
      state.advanceBusinessReportEventsErrorMessage = null;
    },
    getAdvanceBusinessReportEventsFailure: (state, { payload }) => {
      state.advanceBusinessReportEvents = [];
      state.advanceBusinessReportEventsErrorMessage = payload;
    },
    createAdvanceBusinessReportEventSuccess: (state) => {
      state.advanceBusinessReportEventsFlag =
        !state.advanceBusinessReportEventsFlag;
    },
    createAdvanceBusinessReportEventFailure: (state, { payload }) => {
      state.advanceBusinessReportEventsErrorMessage = payload;
    },
    deleteAdvanceBusinessReportEventSuccess: (state) => {
      state.advanceBusinessReportEventsFlag =
        !state.advanceBusinessReportEventsFlag;
    },
    deleteAdvanceBusinessReportEventFailure: (state, { payload }) => {
      state.advanceBusinessReportEventsErrorMessage = payload;
    },
    saveSearchTermsRelevancy: (state) => {
      state.editSearchTermsLoading = true;
    },
    saveSearchTermsRelevancySuccess: (state) => {
      state.editSearchTermsLoading = false;
    },
    saveSearchTermsRelevancyFailure: (state) => {
      state.editSearchTermsLoading = false;
    },
    addSearchTerm: (state) => {
      state.editSearchTermsLoading = true;
    },
    addSearchTermSuccess: (state) => {
      state.editSearchTermsLoading = false;
      state.addNewKeywordResponse = {
        success: true,
        message: "Keyword added successfully, check back in a few hours",
      };
    },
    addSearchTermFailure: (state, { payload }) => {
      state.editSearchTermsLoading = false;
      state.addNewKeywordResponse = {
        success: false,
        message: payload,
      };
    },
    addSearchTermClearResponse: (state) => {
      state.addNewKeywordResponse = {};
    },
  },
});

// Three actions generated from the slice
const {
  getAdvanceBusinessReport,
  initAdvanceBusinessReport,
  getAdvanceBusinessReportSuccess,
  getAdvanceBusinessReportFailure,

  getSponsoredRankTrackingData,
  getSponsoredRankTrackingDataFailure,
  getSponsoredRankTrackingDataSuccess,

  getCaSponsoredRankTrackingData,
  getCaSponsoredRankTrackingDataFailure,
  getCaSponsoredRankTrackingDataSuccess,

  getOrganicRankTrackingData,
  getOrganicRankTrackingDataFailure,
  getOrganicRankTrackingDataSuccess,

  getCaOrganicRankTrackingData,
  getCaOrganicRankTrackingDataFailure,
  getCaOrganicRankTrackingDataSuccess,

  getSkuASINsList,
  getSkuASINsListSuccess,
  getSkuASINsListFailure,

  getProductItemDetails,
  getProductItemDetailsSuccess,
  getProductItemDetailsFailure,

  resetRankTracking,
  resetCaRankTracking,
  setDefaultAdvanceSelectionReport,

  getAdvanceBusinessReportEventsSuccess,
  getAdvanceBusinessReportEventsFailure,

  createAdvanceBusinessReportEventSuccess,
  createAdvanceBusinessReportEventFailure,

  deleteAdvanceBusinessReportEventSuccess,
  deleteAdvanceBusinessReportEventFailure,

  saveSearchTermsRelevancy,
  saveSearchTermsRelevancySuccess,
  saveSearchTermsRelevancyFailure,

  addSearchTerm,
  addSearchTermSuccess,
  addSearchTermFailure,
  addSearchTermClearResponse,
} = advanceBusinessReportSlice.actions;

// A selector
// export const businessReportSelector = (state) => state.business_report;
export const advanceBusinessReportSelector = (state) =>
  state.advance_business_report;

// The reducer
export default advanceBusinessReportSlice.reducer;

// Asynchronous thunk action

export function fetchAdvanceBusinessReport(payload) {
  return async (dispatch) => {
    dispatch(getAdvanceBusinessReport(payload));

    let url = `${atomicConfig.storeManagementServiceUrl}/advance-business-report/${payload.store}?parent_asin=${payload.asin}&sku=${payload.sku}&child_asin=${payload.child_asin}&start_date=${payload.start_date}&end_date=${payload.end_date}&periodicity=${payload.periodicity}`;

    if (payload["compare_start_date"]) {
      url += `&compare_start_date=${payload.compare_start_date}&compare_end_date=${payload.compare_end_date}`;
    }

    try {
      let result = await call_api_auth(url, "GET");

      result = result.data;
      if (result.message !== undefined) {
        dispatch(getAdvanceBusinessReportFailure(result.message));
        dispatch(
          displayErrorWithTimeout({
            url: url,
            content: result.message,
          })
        );
      } else {
        dispatch(getAdvanceBusinessReportSuccess(result));
      }
    } catch (error) {
      const message = error.message || "Something went wrong";
      dispatch(getAdvanceBusinessReportFailure(message));
      dispatch(
        displayErrorWithTimeout({
          url: url,
          content: message,
        })
      );
    }
  };
}

export function resetAdvanceBusinessReport() {
  return async (dispatch) => {
    dispatch(initAdvanceBusinessReport());
  };
}

export function fetchSponsoredRankTrackingData(payload) {
  payload.marketPlace = payload.marketPlace || "us";
  return async (dispatch) => {
    let SponsoredRankTrackingData =
      payload.marketPlace === "us"
        ? getSponsoredRankTrackingData
        : getCaSponsoredRankTrackingData;

    let SponsoredRankTrackingDataFailure =
      payload.marketPlace === "us"
        ? getSponsoredRankTrackingDataFailure
        : getCaSponsoredRankTrackingDataFailure;

    let SponsoredRankTrackingDataSuccess =
      payload.marketPlace === "us"
        ? getSponsoredRankTrackingDataSuccess
        : getCaSponsoredRankTrackingDataSuccess;
    dispatch(SponsoredRankTrackingData(payload));

    const store = String(payload.store ?? "").replace("_client", "");

    let url = `${
      atomicConfig.storeManagementServiceUrl
    }/get-rank-tracking-comp/${store}?${
      payload.child_asin
        ? `child_asin=${payload.child_asin}`
        : `parent_asin=${payload.asin}`
    }&start_date=${payload.startDate}&end_date=${payload.endDate}&periodicity=${
      payload.periodicity
    }&marketplace=${payload.marketPlace}&organic=False`;
    try {
      let result = await call_api_auth(url, "GET");
      result = result.data;

      if (result.message !== undefined) {
        dispatch(SponsoredRankTrackingDataFailure(result.message));
        dispatch(
          displayErrorWithTimeout({
            url: url,
            content: result.message,
          })
        );
      } else {
        dispatch(SponsoredRankTrackingDataSuccess(result));
      }
    } catch (error) {
      const message = error.message || "Something went wrong";
      dispatch(SponsoredRankTrackingDataFailure(message));
      dispatch(
        displayErrorWithTimeout({
          url: url,
          content: message,
        })
      );
    }
  };
}

export function fetchOrganicRankTrackingData(payload) {
  payload.marketPlace = payload.marketPlace || "us";
  return async (dispatch) => {
    let OrganicRankTrackingData =
      payload.marketPlace === "us"
        ? getOrganicRankTrackingData
        : getCaOrganicRankTrackingData;

    let OrganicRankTrackingDataFailure =
      payload.marketPlace === "us"
        ? getOrganicRankTrackingDataFailure
        : getCaOrganicRankTrackingDataFailure;

    let OrganicRankTrackingDataSuccess =
      payload.marketPlace === "us"
        ? getOrganicRankTrackingDataSuccess
        : getCaOrganicRankTrackingDataSuccess;
    dispatch(OrganicRankTrackingData(payload));

    const store = String(payload.store ?? "").replace("_client", "");

    let url = `${
      atomicConfig.storeManagementServiceUrl
    }/get-rank-tracking-comp/${store}?${
      payload.child_asin
        ? `child_asin=${payload.child_asin}`
        : `parent_asin=${payload.asin}`
    }&start_date=${payload.startDate}&end_date=${payload.endDate}&periodicity=${
      payload.periodicity
    }&marketplace=${payload.marketPlace}&organic=True`;
    try {
      let result = await call_api_auth(url, "GET");
      result = result.data;

      if (result.message !== undefined) {
        dispatch(OrganicRankTrackingDataFailure(result.message));
        dispatch(
          displayErrorWithTimeout({
            url: url,
            content: result.message,
          })
        );
      } else {
        dispatch(OrganicRankTrackingDataSuccess(result));
      }
    } catch (error) {
      const message = error.message || "Something went wrong";
      dispatch(OrganicRankTrackingDataFailure(message));
      dispatch(
        displayErrorWithTimeout({
          url: url,
          content: message,
        })
      );
    }
  };
}

export function fetchSkuASINList(payload) {
  return async (dispatch) => {
    dispatch(getSkuASINsList());

    const store = payload.store.replace("_client", "");

    let url = `${atomicConfig.storeManagementServiceUrl}/fetch-sku-and-asin-list/${store}`;

    try {
      let result = await call_api_auth(url, "GET");
      result = result.data;

      if (result.message !== undefined) {
        dispatch(getSkuASINsListFailure(result.message));
        dispatch(
          displayErrorWithTimeout({
            url: url,
            content: result.message,
          })
        );
      } else {
        if (payload["level"]) {
          dispatch(getSkuASINsListSuccess(result[payload["level"]]));
        } else {
          dispatch(getSkuASINsListSuccess(result));
        }
      }
    } catch (error) {
      const message = error.message || "Something went wrong";
      dispatch(getSkuASINsListFailure(message));
      dispatch(
        displayErrorWithTimeout({
          url: url,
          content: message,
        })
      );
    }
  };
}

export function fetchProductItemDetails(payload) {
  return async (dispatch) => {
    dispatch(getProductItemDetails());
    const { store, level } = payload;

    let url = `${atomicConfig.storeManagementServiceUrl}/fetch-product-item-details/${store}?level=${level}&marketplace=us`;

    try {
      let result = await call_api_auth(url, "GET");
      if (result?.error) {
        dispatch(getProductItemDetailsFailure(result.error));
        dispatch(
          displayErrorWithTimeout({
            url: url,
            content: result.error,
          })
        );
      } else {
        dispatch(getProductItemDetailsSuccess(result.data.product_item[0]));
      }
    } catch (error) {
      const message = error.message || "Something went wrong";
      dispatch(getProductItemDetailsFailure(message));
      dispatch(
        displayErrorWithTimeout({
          url: url,
          content: message,
        })
      );
    }
  };
}

export function fetchAdvanceBusinessReportEvents(payload) {
  return async (dispatch) => {
    const store = String(payload.store ?? "").replace("_client", "");
    let url = `${atomicConfig.storeManagementServiceUrl}/advance-report-events/${store}?parent_asin=${payload.asin}&sku=${payload.sku}&child_asin=${payload.child_asin}&start_date=${payload.startDate}&end_date=${payload.endDate}`;

    try {
      let result = await call_api_auth(url, "GET");
      result = result.data;
      if (result) {
        dispatch(getAdvanceBusinessReportEventsSuccess(result));
      }
    } catch (error) {
      const message = error.message || "Something went wrong";
      dispatch(getAdvanceBusinessReportEventsFailure(message));
      dispatch(
        displayErrorWithTimeout({
          url: url,
          content: message,
        })
      );
    }
  };
}

export function addAdvanceBusinessReportEvent(payload) {
  return async (dispatch) => {
    const store = String(payload.store ?? "").replace("_client", "");
    let url = `${atomicConfig.storeManagementServiceUrl}/advance-report-events/${store}`;
    let json_body = JSON.stringify(payload);

    try {
      let result = await call_api_auth(url, "POST", json_body);
      result = result.data;
      if (result) {
        dispatch(createAdvanceBusinessReportEventSuccess(payload));
      }
    } catch (error) {
      const message = error.message || "Something went wrong";
      dispatch(createAdvanceBusinessReportEventFailure(message));
      dispatch(
        displayErrorWithTimeout({
          url: url,
          content: message,
        })
      );
    }
  };
}

export function removeAdvanceBusinessReportEvent(payload) {
  return async (dispatch) => {
    const store = String(payload.store ?? "").replace("_client", "");
    let url = `${atomicConfig.storeManagementServiceUrl}/advance-report-events/${store}`;
    let json_body = JSON.stringify({ event_id: payload.event_id });

    try {
      let result = await call_api_auth(url, "DELETE", json_body);
      result = result.data;
      if (result) {
        dispatch(deleteAdvanceBusinessReportEventSuccess(result));
      }
    } catch (error) {
      const message = error.message || "Something went wrong";
      dispatch(deleteAdvanceBusinessReportEventFailure(message));
      dispatch(
        displayErrorWithTimeout({
          url: url,
          content: message,
        })
      );
    }
  };
}

export function resetRankTrackingData() {
  return async (dispatch) => {
    dispatch(resetRankTracking());
  };
}
export function resetCaRankTrackingData() {
  return async (dispatch) => {
    dispatch(resetCaRankTracking());
  };
}

export function changeDefaultAdvanceSelectionReport(payload) {
  return async (dispatch) => {
    dispatch(setDefaultAdvanceSelectionReport(payload));
  };
}

export function updateSearchTermsRelevancy(payload) {
  return async (dispatch) => {
    dispatch(saveSearchTermsRelevancy());

    const store = payload.store.replace("_client", "");
    const child_asin = payload.child_asin;

    let url = `${atomicConfig.storeManagementServiceUrl}/upsert-searchterms-relevancies/${store}?child_asin=${child_asin}`;
    let json_body = JSON.stringify(payload.rows);

    try {
      let result = await call_api_auth(url, "POST", json_body);
      result = result.data;
      if (result) {
        dispatch(saveSearchTermsRelevancySuccess(result));
      }
    } catch (error) {
      const message = error.message || "Something went wrong";
      dispatch(saveSearchTermsRelevancyFailure());
      dispatch(
        displayErrorWithTimeout({
          url: url,
          content: message,
        })
      );
    }
  };
}

export function createSearchTerm(payload) {
  return async (dispatch) => {
    dispatch(addSearchTerm());

    const store = String(payload.store ?? "").replace("_client", "");
    const marketplace = payload.marketPlace || "us";

    // The Rainforest collection is derived backend-side from the store and the
    // marketplace; a caller-supplied collection name is what the deprecated
    // route could not enforce.
    let url = `${atomicConfig.storeManagementServiceUrl}/add-new-search-term/${store}?marketplace=${marketplace}`;
    let json_body = JSON.stringify({ search_terms: payload.search_terms });

    try {
      let result = await call_api_auth(url, "POST", json_body);
      result = result.data;
      if (result) {
        dispatch(addSearchTermSuccess());
      }
    } catch (error) {
      let message;
      if (error.response) {
        message = error.response.data.error;
      } else {
        message = error.message || "Something went wrong";
        dispatch(
          displayErrorWithTimeout({
            url: url,
            content: message,
          })
        );
      }
      dispatch(addSearchTermFailure(message));
    }
  };
}

export function addSearchTermClear() {
  return async (dispatch) => {
    dispatch(addSearchTermClearResponse());
  };
}
